"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REMEMBER_KEY = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _logoWorkfluxPortal = _interopRequireDefault(require("../../@assets/images/workflux/logo-workflux-portal.svg"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _CompanyList = _interopRequireDefault(require("./components/CompanyList"));
var _hooks = require("../../@hooks");
require("./styles.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var REMEMBER_KEY = '@rememberAccess';
exports.REMEMBER_KEY = REMEMBER_KEY;
var ChoosePortal = function ChoosePortal() {
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useQueryParams = (0, _hooks.useQueryParams)(),
    removeRememberAccess = _useQueryParams.removeRememberAccess;
  (0, _react.useEffect)(function () {
    var hostname = window.location.hostname;
    if (hostname === 'portal-workflux.web.app') {
      window.open('https://portal.workflux.digital/', '_self');
    }
  }, [window.location]);
  (0, _react.useEffect)(function () {
    if (removeRememberAccess) {
      localStorage.removeItem(REMEMBER_KEY);
      return;
    }
    var rememberAccessLocal = localStorage.getItem(REMEMBER_KEY);
    var rememberAccessParsed = JSON.parse(rememberAccessLocal);
    if (!removeRememberAccess && rememberAccessParsed !== null && rememberAccessParsed !== void 0 && rememberAccessParsed.remember) {
      window.open(rememberAccessParsed === null || rememberAccessParsed === void 0 ? void 0 : rememberAccessParsed.domain, '_self');
    }
  }, [removeRememberAccess]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ChoosePortal"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _logoWorkfluxPortal["default"],
    alt: "Workflux Portal Logo"
  }), /*#__PURE__*/_react["default"].createElement(_CompanyList["default"], {
    loading: isLoading,
    setIsLoading: setIsLoading
  }), /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    loading: isLoading,
    title: "Voc\xEA est\xE1 sendo redirecionado para o portal selecionado"
  }));
};
var _default = ChoosePortal;
exports["default"] = _default;